import { render, staticRenderFns } from "./set-password.vue?vue&type=template&id=2bf949bc&scoped=true&"
import script from "./set-password.vue?vue&type=script&lang=js&"
export * from "./set-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf949bc",
  null
  
)

export default component.exports